import React from 'react';


const FooterFragment = React.memo(()=> {
    const footerNavigation = [
        {
            name: 'Linkedin',
            href: '#',
            icon: (props:any) => (
                <svg fill="currentColor" viewBox="0 0 16 16" {...props}>
                    <path
                        fillRule="evenodd"
                        d="M12.225 12.225h-1.778V9.44c0-.664-.012-1.519-.925-1.519-.926 0-1.068.724-1.068 1.47v2.834H6.676V6.498h1.707v.783h.024c.348-.594.996-.95 1.684-.925 1.802 0 2.135 1.185 2.135 2.728l-.001 3.14zM4.67 5.715a1.037 1.037 0 01-1.032-1.031c0-.566.466-1.032 1.032-1.032.566 0 1.031.466 1.032 1.032 0 .566-.466 1.032-1.032 1.032zm.889 6.51h-1.78V6.498h1.78v5.727zM13.11 2H2.885A.88.88 0 002 2.866v10.268a.88.88 0 00.885.866h10.226a.882.882 0 00.889-.866V2.865a.88.88 0 00-.889-.864z"
                        clipRule="evenodd"
                    />
                </svg>
            ),
        },
    ]
    return <footer className="bg-white mt-16 sticky top-[100vh]">
        <div className="mx-auto max-w-7xl px-6 py-6 md:flex md:items-center md:justify-between lg:px-8">
            <div className="flex justify-center space-x-6 md:order-2">
                {footerNavigation.map((item) => (
                    <a key={item.name} href={item.href}
                       className="text-gray-400 hover:text-gray-500 pointer-events-none">
                        <span className="sr-only">{item.name}</span>
                        <item.icon className="h-6 w-6" aria-hidden="true"/>
                    </a>
                ))}
            </div>
            <div className="mt-4 md:order-1 md:mt-0">
                <p className="text-center text-xs leading-5 text-gray-500">
                    &copy; 2026 RoomPulse Inc. All rights reserved.
                </p>
            </div>
        </div>
    </footer>
});

export default FooterFragment;